import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import { AppHeaderDropdown } from './header/index'
import logo_1 from 'src/assets/images/logo.png'
import { SetSidebarVisibility } from 'src/Thunk/adminThunks'


const AppHeader = () => {
  const dispatch = useDispatch()
  const {sidebarShow} = useSelector((state) => state.admin)
  const sidebarBrandStyle = {
    backgroundColor: '#3c4b64', // Set the background color to gray
    // Optional padding
  };

  return (
    <CHeader position="sticky" className="mb-4  header " style={sidebarBrandStyle}>
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch(SetSidebarVisibility(!sidebarShow))}
        >
          <CIcon icon={cilMenu} size="lg" className='text-white' />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/dashboard">
          <CIcon icon={logo_1} height={48} alt="Logo" to="/dashboard" />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto ">
          <CNavItem>
            <CNavLink to="/dashboard" component={NavLink} className="text-info"></CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-3 ">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
